<div class="flex flex-col gap-4" [ngClass]="{ '!w-[31.25rem]': isDesktop }" [class]="direction">
  <!--
    a11y: header row reordered so the close button is FIRST in DOM (audit:
    "Arrange DOM order: close button -> title -> content"). focusInitial=true
    marks the inner native <button> with `cdkFocusInitial` so our CDK focus
    trap (DialogComponent.ngAfterViewInit) lands focus here on open, instead
    of letting Material auto-focus the Cancel button at the bottom.
    Visual position is preserved by tailwind `order-*` utilities: heading
    keeps its leading slot, the close button stays on the trailing side.
  -->
  <div class="flex justify-between">
    <mot-button matType="icon" icon="close" [ariaLabel]="closeText" (onClick)="closeCard()" [focusInitial]="true" class="order-2" />

    <div class="flex gap-2 items-center order-1">
      <ng-icon class="text-2xl" name="heart-filled" aria-hidden="true" />
      <!-- a11y: popup heading is h2 (page-level h1 is the nav-bar logo). -->
      <h2 class="text-base">
        {{ !!this.data.favorite ? editFavoriteText : newFavoriteText }}
      </h2>
    </div>
  </div>

  <form [formGroup]="favoriteForm" class="flex flex-col gap-6 pb-6" [ngClass]="{ 'px-4': !!isDesktop }">
    <div class="flex flex-col gap-2">
      <mot-select formControlName="type" [options]="favoriteTypes$" [label]="favoriteTypeText" class="w-full text-start"
        labelClass="text-[#5C748F]" />

      <ng-container *ngIf="!!favoriteForm.controls['type'].value" [ngSwitch]="favoriteForm.controls['type'].value">
        <ng-container *ngSwitchCase="eFavoriteType.ROUTES">
          <ng-container *ngTemplateOutlet="routeForm" />
        </ng-container>

        <ng-container *ngSwitchCase="eFavoriteType.STATIONS">
          <ng-container *ngTemplateOutlet="stationForm" />
        </ng-container>

        <ng-container *ngSwitchCase="eFavoriteType.LINES">
          <ng-container *ngTemplateOutlet="lineForm" />
        </ng-container>
      </ng-container>
    </div>

    <div class="flex gap-4 justify-end items-center" [ngClass]="{ 'flex-col': !!isMobile }">

      <mot-button buttonClass="!bg-transparent w-full !text-black !align-middle" [text]="cancelText"
        (onClick)="closeCard()">
      </mot-button>

      <mot-button [disabled]="!formContext.valid"
        buttonClass="not-disabled:!bg-primary w-full !text-white !py-6 !rounded-lg !align-middle"
        [text]="!!this.data.favorite ? saveFavoriteText : addFavoriteText" (onClick)="
          !!this.data.favorite
            ? saveFavorite(favoriteForm.controls['type'].value)
            : addFavorite(favoriteForm.controls['type'].value);
          closeCard()
        " [ngClass]="{ 'w-full': !!isMobile }"></mot-button>

    </div>
  </form>

  <ng-template #routeForm>
    <form [formGroup]="getNestedGroup('formValues')" class="flex flex-col gap-2">
      <mot-autocomplete formControlName="origin" [displayErrors]="false" [options]="originCompleteOptions$"
        appearance="fill" [label]="originText" fieldClass="bg-transparent w-full !text-default"
        [displayFn]="routePlanningService.displayAddressName" labelClass="text-[#5C748F]" />

      <mot-autocomplete formControlName="destination" [displayErrors]="false" [options]="destinationCompleteOptions$"
        appearance="fill" [label]="destinationText" fieldClass="bg-transparent w-full !text-default"
        [displayFn]="routePlanningService.displayAddressName" labelClass="text-[#5C748F]" />
    </form>
  </ng-template>

  <ng-template #stationForm>
    <form [formGroup]="formContext" class="flex flex-col gap-2">
      <mot-autocomplete formControlName="stop" [displayErrors]="false" appearance="fill" [label]="SearchStationText"
        [options]="autoCompleteOptions$" [displayFn]="routePlanningService.displayStopDetails"
        labelClass="text-[#5C748F]" fieldClass="cursor-pointer bg-transparent w-full !text-default"
        (textChange)="searchSubject$.next($event)" [hasTrigger]="true">
        <ng-template #customOption let-option>
          <div class="flex gap-2 items-center">
            <ng-icon name="station" class="text-xl colored-icon" />
            <div class="flex flex-col flex-1">
              <span *ngIf="option.value.name" class="text-[13px]">{{
                option.value.name
                }}</span>
              <!-- contrast: tailwind config text-gray-600 (~2.6:1) fails AA; subText (~4.9:1) passes. -->
              <small *ngIf="option.value.stopcode" class="text-subText">{{ stationCodeText }}: {{ option.value.stopcode
                }}</small>
            </div>
          </div>
        </ng-template>
      </mot-autocomplete>
      <div class="flex items-center">
        <ng-icon [name]="'circle-info'" class="text-2xl text-[#5C748F]" />
        <span class="text-xs text-[#5C748F] font-normal mt-1">{{searchByStationLabelText}}</span>
      </div>
    </form>
  </ng-template>

  <ng-template #lineForm>
    <form [formGroup]="formContext" class="flex flex-col gap-2">
      <mot-autocomplete formControlName="line" [displayErrors]="false" appearance="fill" [label]="searchLineText"
        [options]="autoCompleteOptions$" fieldClass="cursor-pointer bg-transparent w-full !text-default"
        labelClass="text-[#5C748F]" [displayFn]="routePlanningService.displayLineName"
        (textChange)="searchSubject$.next($event)" (onOptionSelected)="setLineValue($event)" [hasTrigger]="true">
        <ng-template #customOption let-option>
          <div class="flex gap-2 items-center">
            <img [src]="option.value.agencyId | agencyLogo" [attr.alt]="option.value.agencyName" class="h-6" />
            <div class="flex flex-col flex-1">
              <span *ngIf="option.value.routeName" class="text-[13px]">
                {{ option.value.routeName }} {{ option.value.cityName }}</span>
            </div>
          </div>
        </ng-template>
      </mot-autocomplete>
      <div class="flex items-center">
        <ng-icon [name]="'circle-info'" class="text-2xl text-[#5C748F]" />
        <span class="text-xs text-[#5C748F] font-normal mt-1">{{searchByLineNumberAndCityText}}</span>
      </div>
    </form>
  </ng-template>
</div>